export const getPromptBeforeExitFeature = ({ features }) => features.promptBeforeExitFeature;
